import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { Store } from 'src/store';
import sendPostMessage from 'src/store/app/operation/sendPostMessage';
import { MESSAGE_TYPE } from 'src/store/app/types';
import { BatchSelectionItem, computeBatchSelectionTotals } from 'src/util/apparel/batchSelection';

/**
 * OP-40008: the editor reports every quantity change in the batch selection
 * modal; recompute the footer totals host-side and push them back. Acts only
 * while the host itself has a modal open — the message channel is shared with
 * the whole window, so an unsolicited message must not drive host state.
 */
const handleBatchSelectionChangedOperation = (items: BatchSelectionItem[]) => (
  dispatch: ThunkDispatch<Store, undefined, AnyAction>,
  getState: () => Store,
) => {
  // Ignore anything that arrives while the host has no modal in flight.
  if (!getState().multisize.isBatchSelectionOpen) {
    return;
  }

  sendPostMessage({
    type: MESSAGE_TYPE['batchSelection.setTotals'],
    data: computeBatchSelectionTotals(getState(), items || []),
  });
};

export default handleBatchSelectionChangedOperation;
